import { Loader2, Upload } from "lucide-react";
import type { ChangeEvent, RefObject } from "react";
import styles from "./DocumentUploadButton.module.scss";

type DocumentUploadButtonProps = {
  fileInputRef: RefObject<HTMLInputElement | null>;
  accept: string;
  disabled: boolean;
  isImporting: boolean;
  onFileInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClick: () => void;
};

export function DocumentUploadButton({
  fileInputRef,
  accept,
  disabled,
  isImporting,
  onFileInputChange,
  onClick,
}: DocumentUploadButtonProps) {
  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        className={styles.fileInput}
        onChange={onFileInputChange}
      />
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={styles.uploadButton}
      >
        {isImporting ? (
          <Loader2 size={13} className={styles.spinIcon} />
        ) : (
          <Upload size={13} />
        )}
        {isImporting ? "Processing…" : "Upload"}
      </button>
    </>
  );
}
